import { externalLink } from "@/routes/_constants/external-link";

import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "手間いらずと連携する方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/temairazu/settings.jpg",
		url: `${externalLink.faqSite}/faq/host/site-controller/3d8fffe15c578017a8d6c5cbcf82d6f7`,
	},
];
